var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { ref: "tableList", staticClass: "yxtbiz-select-rank-table-list" },
    [
      _c(
        "yxt-table",
        {
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "row-key": function (row) {
              return row.sourceId
            },
            height: "100%",
          },
        },
        [
          _c("yxt-table-column", {
            attrs: {
              prop: "title",
              label: _vm.$t("pc_biz_select_rank_title"),
              width: "200",
            },
          }),
          _c("yxt-table-column", {
            attrs: {
              label: _vm.$t("pc_biz_select_rank_content"),
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.showName(scope.row)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "yxt-table-column",
            {
              attrs: {
                label: _vm.$t("pc_biz_select_rank_range"),
                width: "200",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "select-rank-tab-checkbox" }, [
                        scope.row.showGroupRankList
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.checkBoxClick(
                                      !scope.row.groupChecked &&
                                        _vm.selectedValue.length ===
                                          _vm.maxLength
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "yxt-checkbox",
                                  {
                                    attrs: {
                                      disabled:
                                        !scope.row.groupChecked &&
                                        _vm.selectedValue.length ===
                                          _vm.maxLength,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.selectRow(
                                          scope.row,
                                          "groupChecked",
                                          "platformChecked"
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.groupChecked,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "groupChecked", $$v)
                                      },
                                      expression: "scope.row.groupChecked",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("pc_biz_select_rank_group"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.checkBoxClick(
                                  !scope.row.platformChecked &&
                                    _vm.selectedValue.length === _vm.maxLength
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "yxt-checkbox",
                              {
                                attrs: {
                                  disabled:
                                    !scope.row.platformChecked &&
                                    _vm.selectedValue.length === _vm.maxLength,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectRow(
                                      scope.row,
                                      "platformChecked",
                                      "groupChecked"
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.platformChecked,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "platformChecked", $$v)
                                  },
                                  expression: "scope.row.platformChecked",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("pc_biz_select_rank_platform"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "yxt-tooltip",
                    { attrs: { effect: "dark", placement: "top" } },
                    [
                      _c("template", { slot: "content" }, [
                        _c(
                          "div",
                          { staticClass: "pc-biz-select-rank-tooptip" },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("pc_biz_select_rank_tooltip_tips")
                                )
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_biz_select_rank_tooltip_tips_normal"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("yxt-svg", {
                        staticClass: "color-gray-6 hover-primary-6",
                        staticStyle: { "vertical-align": "text-bottom" },
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "icons/question-cirlce-o",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }